import { DH, Meses } from "../../models/general/utils.interface";

export const documentosEstadoCuenta = [
  { codigo: false, descri: 'Todos los documentos' },
  { codigo: true, descri: 'Documentos pendientes' }
]

export const creditosCliente = [
  { codigo: 0, descri: 'Cerrado' },
  { codigo: 1, descri: 'Abierto' }
]

export const sexos = [
  { codsex: 'M', descri: 'Masculino' },
  { codsex: 'F', descri: 'Femenino' }
]

export const dhList: DH[] = [
  { cod: 'D', descri: 'Debe' },
  { cod: 'H', descri: 'Haber' }
]
// LISTAS UTILITARIAS
export const allMeses: Meses[] = [
  { id: 1, nombre: 'Enero' },
  { id: 2, nombre: 'Febrero' },
  { id: 3, nombre: 'Marzo' },
  { id: 4, nombre: 'Abril' },
  { id: 5, nombre: 'Mayo' },
  { id: 6, nombre: 'Junio' },
  { id: 7, nombre: 'Julio' },
  { id: 8, nombre: 'Agosto' },
  { id: 9, nombre: 'Septiembre' },
  { id: 10, nombre: 'Octubre' },
  { id: 11, nombre: 'Noviembre' },
  { id: 12, nombre: 'Diciembre' },
]

export const allMesesWithTodos: Meses[] = [
  { id: -1, nombre: 'Todos' },
  { id: 1, nombre: 'Enero' },
  { id: 2, nombre: 'Febrero' },
  { id: 3, nombre: 'Marzo' },
  { id: 4, nombre: 'Abril' },
  { id: 5, nombre: 'Mayo' },
  { id: 6, nombre: 'Junio' },
  { id: 7, nombre: 'Julio' },
  { id: 8, nombre: 'Agosto' },
  { id: 9, nombre: 'Septiembre' },
  { id: 10, nombre: 'Octubre' },
  { id: 11, nombre: 'Noviembre' },
  { id: 12, nombre: 'Diciembre' },
]

export const allMesesWithApertura: Meses[] = [
  { id: -1, nombre: 'Apertura' },
  { id: 1, nombre: 'Enero' },
  { id: 2, nombre: 'Febrero' },
  { id: 3, nombre: 'Marzo' },
  { id: 4, nombre: 'Abril' },
  { id: 5, nombre: 'Mayo' },
  { id: 6, nombre: 'Junio' },
  { id: 7, nombre: 'Julio' },
  { id: 8, nombre: 'Agosto' },
  { id: 9, nombre: 'Septiembre' },
  { id: 10, nombre: 'Octubre' },
  { id: 11, nombre: 'Noviembre' },
  { id: 12, nombre: 'Diciembre' },
]

export const allMesesWithApertura0: Meses[] = [
  { id: 0, nombre: 'Apertura' },
  { id: 1, nombre: 'Enero' },
  { id: 2, nombre: 'Febrero' },
  { id: 3, nombre: 'Marzo' },
  { id: 4, nombre: 'Abril' },
  { id: 5, nombre: 'Mayo' },
  { id: 6, nombre: 'Junio' },
  { id: 7, nombre: 'Julio' },
  { id: 8, nombre: 'Agosto' },
  { id: 9, nombre: 'Septiembre' },
  { id: 10, nombre: 'Octubre' },
  { id: 11, nombre: 'Noviembre' },
  { id: 12, nombre: 'Diciembre' },
]

export const allMesesObj = {
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre'
}

export const fileTypes = {
  pdf: 'application/pdf',
  jpeg: 'image/jpeg',
  png: 'image/png',
  jpg: 'image/jpg',
}

//FUNCIONES
export function refresh(): void {
  window.location.reload()
}

export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  return `${year}-${month}-${day}`
}

export function getFechaPeriodoAnterior(cantidad?: number) {
  const fechaActual = new Date();
  const nuevaFecha = new Date(fechaActual);
  nuevaFecha.setFullYear(fechaActual.getFullYear() - (cantidad ?? 1));
  return formatDate(nuevaFecha)
}

export const fechaActual = formatDate(new Date())
export const fechaPeriodoAnterior = new Date().setFullYear(new Date().getFullYear() - 1);
export const fechaAnioPasado = formatDate(new Date(new Date().setFullYear(new Date().getFullYear() - 1)))


export const constosEspeciales: number[] = [2, 3, 4];
export const constosSubEspecial: number[] = [2, 4];


export function beep() {
  const context = new AudioContext();
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();

  oscillator.type = 'triangle';
  oscillator.frequency.value = 1040;

  gainNode.gain.setValueAtTime(0.4, context.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 0.3);

  oscillator.connect(gainNode);
  gainNode.connect(context.destination);

  oscillator.start(context.currentTime);
  oscillator.stop(context.currentTime + 0.3);

}